import * as React from "react";
import {Fragment, Component, createRef} from "react";
import Modal from "../Modal/Modal";
import Summary from "./Summary";
import FetchData from "../../backend/FetchData";
import Spinner from "../Process/Spinner";
import KeySolver from "../../KeySolver";

class Request extends Component {

	constructor(props) {
		super(props);
		this.state = {
			showModal: false,
			sending: false,
			partner: false,
			fetching: false,
			selectedPartner: false,
		}
		this.form = createRef();
		this.showModal = this.showModal.bind(this);
		this.submit = this.submit.bind(this);
		this.selectPartner = this.selectPartner.bind(this);
		this.resetPartner = this.resetPartner.bind(this);
	}

	showModal() {
		this.setState(prevState => ({
			showModal: !prevState.showModal
		}));
	}

	selectPartner(email) {
		this.setState({selectedPartner: email}, () => {
			console.log(this.state.selectedPartner)
		});
	}

	submit(el) {
		el.preventDefault();

		const {selectedPartner} = this.state;

		if(selectedPartner) {

			this.setState({sending: true}, () => {
				FetchData('/api/configurator/request/create', 'POST', false, false, el.target, true).then(result => {
					if(result.response === 'success') {
						this.setState({sending: false}, () => {
							this.setState({sent: true});
						})
					}
				});
			})

		} else {

			this.setState({fetching: true}, () => {

				const form = el.target;
				const formData = new FormData(form);
				const formDataForPartnerRequest = new FormData(form);

				formData.forEach((value, key) => {
					console.log(`${key}: ${value}`)
					if(key === 'request[properties][contact][zip]') {
						formDataForPartnerRequest.append('zip', value);
					}
					if(key === 'request[properties][contact][city]') {
						formDataForPartnerRequest.append('city', value);
					}
					if(key === 'request[properties][contact][country]') {
						formDataForPartnerRequest.append('country', value);
					}
				});

				fetch('/api/getpartner', {method: 'POST', redirect: 'follow', body: formDataForPartnerRequest})
					.then(response => response.json())
					.then(result => {
						this.setState({partner: result}, () => {
							console.log(this.state.partner)
							this.setState({fetching: false});
						});
					})
					.catch(error => console.log('error', error));

			});

		}

	}

	resetPartner() {
		this.setState({partner: false});
	}

	render() {

		const {showModal, sending, sent, partner, fetching, selectedPartner} = this.state;
		const {name, children} = this.props;

		return (
			<Fragment>
				<div id="requestButton">
					<button type="button" className="btn btn-primary text-white" onClick={() => this.showModal()} >Anfrage senden</button>
				</div>
				{showModal &&
					<Modal id="requestModal" title="Unverbindliche Anfrage senden" size="xl" onClose={() => this.showModal()}>

						{sending &&
							<div className="d-flex align-items-center text-center justify-content-center my-5">
								<Fragment>
									<Spinner style="rotate" />
									<span className="ms-3 text-primary">
										Anfrage wird gesendet
									</span>
								</Fragment>
							</div>
						}

						{sent &&
							<div className="d-flex align-items-center text-center justify-content-center my-5">
								<Fragment>
									<span className="ms-3 text-primary">
										Deine Anfrage wurde erfolgreich versendet.
									</span>
								</Fragment>
							</div>
						}

						{!sending && !sent &&
							<form onSubmit={(p) => this.submit(p)} style={{opacity: (fetching ? '0.5' : '1'), pointerEvents: (fetching ? 'none' : 'all')}} >
								<div className="row">
									<div className="col-md-6">
										{/*<p>Haben Sie schon etwas Schönes gefunden? Oder möchten Sie mit einem qualifizierten Fachhandel in Ihrer Nähe über dieses Produkt sprechen? Dann senden Sie uns hier eine unverbindliche Anfrage und jemand wird sich in Kürze bei Ihnen melden.</p>*/}
										<p>Dies ist eine symbolische Darstellung Ihres Wunschprodukts. Haben Sie Ihr passendes Produkt bereits konfiguriert oder sind Sie noch unsicher über Ihre Wünsche und Anforderungen? Unsere Fachhändler:innen in Ihrer Nähe stehen Ihnen gerne zur Beratung zur Verfügung. Senden Sie uns hier eine unverbindliche Anfrage.</p>
										<input type="hidden" name="request[properties][product][name]" defaultValue={name} required={true} />

										<div className="row mt-4 mb-3">
											<div className="col-6">
												<label className="form-label" htmlFor="firstname">Vorname <sup>*</sup></label>
												<input id="firstname" type="text" name="request[properties][contact][firstname]" className="form-control" placeholder="Vorname" required={true} />
											</div>
											<div className="col-6">
												<label className="form-label" htmlFor="lastname">Nachname <sup>*</sup></label>
												<input id="lastname" type="text" name="request[properties][contact][lastname]" className="form-control" placeholder="Nachname" required={true} />
											</div>
										</div>

										<div className="row my-3">
											<div className="col-6">
												<label className="form-label" htmlFor="email">E-Mail Adresse <sup>*</sup></label>
												<input id="email" type="text" name="request[properties][contact][email]" className="form-control" placeholder="E-Mail Adresse" required={true} />
											</div>
											<div className="col-6">
												<label className="form-label" htmlFor="phone">Telefon</label>
												<input id="phone" type="text" name="request[properties][contact][phone]" className="form-control" placeholder="Telefon" />
											</div>
										</div>

										<div className="row my-3">
											<div className="col-6">
												<label className="form-label" htmlFor="country">Land <sup>*</sup></label>
												{/*<input id="country" type="text" name="request[properties][contact][country]" className="form-control" placeholder="Land" required={true} />*/}
												<select id="country" name="request[properties][contact][country]" className="form-select" required={true} onChange={() => this.resetPartner()}>
													<option value="AT">🇦🇹 Austria (Österreich)</option>
													<option value="CH">🇨🇭 Switzerland</option>
													<option value="CZ">🇨🇿 Czechia</option>
													<option value="DE">🇩🇪 Germany</option>
													<option value="FR">🇫🇷 France</option>
													<option value="HU">🇭🇺 Hungary</option>
													<option value="IT">🇮🇹 Italy</option>
													<option value="SK">🇸🇰 Slovakia</option>
													<option value="SI">🇸🇮 Slovenia</option>
												</select>
											</div>
											<div className="col-6">
												<div className="row">
													<div className="col-md-5">
														<label className="form-label" htmlFor="zip">PLZ <sup>*</sup></label>
														<input id="zip" type="text" name="request[properties][contact][zip]" className="form-control" placeholder="Postleitzahl" required={true} onChange={() => this.resetPartner()}/>
													</div>
													<div className="col-md-7">
														<label className="form-label" htmlFor="city">Ort <sup>*</sup></label>
														<input id="city" type="text" name="request[properties][contact][city]" className="form-control" placeholder="Ort" required={true} onChange={() => this.resetPartner()}/>
													</div>
												</div>
											</div>
										</div>

										<div className="col-12">
											<label className="form-label" htmlFor="message">Nachricht</label>
											<textarea id="message" name="request[properties][contact][message]" className="form-control" placeholder="Nachricht" rows="8"></textarea>
										</div>

										<div className="col-12 mt-3 mb-4">
											<div className="form-check">
												<input className="form-check-input" type="checkbox" value="1" id="privacy" />
												<label className="form-check-label" htmlFor="privacy">
													Ich akzeptiere die Verarbeitung und Speicherung der oben angegebenen Daten zum Zweck der Abwicklung der Anfrage gemäß der Datenschutzrichtlinien.
												</label>
											</div>
										</div>

										{!partner &&
											<div className="row">
												<div className="col-6">
													<button type="button" className="btn btn-outline-primary d-block w-100" onClick={() => this.showModal()}>Anfrage abbrechen</button>
												</div>
												<div className="col-6">
													<button type="submit" className="btn btn-primary d-block w-100">Anfrage absenden</button>
												</div>
											</div>
										}

									</div>
									<div className="col-md-6 position-relative product-overview">

										<h5 className="mb-4">
											{!partner ?
												<Fragment>
													Übersicht deines Produkts
												</Fragment>
												:
												<Fragment>
													An welchen Partner möchten Sie Ihre Anfrage senden?
												</Fragment>
											}
										</h5>

										<div className={partner ? 'd-none' : ''}>
											<Summary children={children}/>
										</div>

										{fetching &&
											<div className="fetching-partner">
												<div className="row h-100 align-items-center">
													<div className="col-12 text-center">
														Partner werden geladen
													</div>
												</div>
											</div>
										}

										{partner && partner.length > 0 &&
											<Fragment>
												<ul className="partner">
													{partner.map(partner =>
														<li key={KeySolver()} className={`partner-item ${selectedPartner === partner.email ? 'selected' : ''}`} onClick={() => this.selectPartner(partner.email)}>
															<div className="row align-items-center">
																<div className="col-3">
																	{partner.logo &&
																		<img src={`https://storage.googleapis.com/woundwo_partner/${partner.logo}`} className="img-fluid"/>
																	}
																</div>
																<div className="col-7">
																	<h5>{partner.company}</h5>
																	<div className="d-block">
																		{partner.address}
																	</div>
																	<div className="d-block">
																		{partner.zip} {partner.city}, {partner.country}
																	</div>
																	<div className="d-block mt-3">
																		<strong>Entfernung:</strong> {partner.distanceString} km
																	</div>
																</div>
															</div>
														</li>
													)}
												</ul>
											</Fragment>
										}

										{selectedPartner &&
											<input type="hidden" name="request[properties][contact][partner]" defaultValue={selectedPartner}/>
										}

										{selectedPartner &&
											<div className="d-block mt-3">
												<button type="submit" className="btn btn-primary d-block w-100">Anfrage absenden</button>
											</div>
										}

									</div>
								</div>
							</form>
						}
					</Modal>
				}
			</Fragment>
		);
	}
}

export default Request;
